/*
 * @Author: your name
 * @Date: 2021-06-27 16:35:30
 * @LastEditTime: 2021-07-02 16:53:01
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zlt-front-end\src\TASMini\api\im.js
 */
import request from '../../utils/request'
//消息发送
export function sendMsgs(data) {
    return request({
        url: '/im/business-im/sendImMsg',
        method: 'post',
        data
    })
}
// 获取im账号
export function queryByUser(params) {
    return request({
        url: '/im/business-im/queryByUserCodeOrgCode',
        method: 'GET',
        params
    })
}
// 获取好友列表

export function getGroupFriend(data) {
    return request({
        url: '/im/business-im/getGroupFriend',
        method: 'POST',
        data
    })
}

// 获取供应商列表
export function getOrgGroupFriend(data) {
    return request({
        url: '/im/business-im/getOrgGroupFriend',
        method: 'POST',
        data
    })
}

// 获取自由销售人列表
export function friendListModel(data) {
    return request({
        url: '/im/business-im/friendListModel',
        method: 'POST',
        data
    })
}


// 多选发送自定义消息
export function sendBatchCustomMsg(data) {
    return request({
        url: '/im/business-im/sendBatchCustomMsg',
        method: 'POST',
        data
    })
}

// im批量发文本消息
export function batchSendMsg(data) {
    return request({
        url: '/im/business-im/batchSendMsg',
        method: 'POST',
        data
    })
}




// WEBPACK FOOTER //
// ./src/SRM/api/im.js